var _path, _path2, _path3, _path4, _path5, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 0v151h150V0zm0 0M151 151H0V0h151zm0 0",
    fill: "#25d9f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 151H361V0h151zm0 0",
    fill: "#00c0f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181 181v150h150V181zm0 0M151 331H0V181h151zm0 0",
    fill: "#25d9f8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512 331H361V181h151zm0 0",
    fill: "#00c0f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M181 361v151h150V361zm0 0M151 512H0V361h151zm0 0",
    fill: "#25d9f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00c0f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 512H361V361h151zm0 0M256 0h75v151h-75zm0 0M256 181h75v150h-75zm0 0M256 361h75v151h-75zm0 0"
  }))));
}

export default __webpack_public_path__ + "c05c24020568648f03ddf7e090262a72.svg";
export { SvgCategory as ReactComponent };